export default __webpack_public_path__ + "images/personal_baggage.4ae937c.svg";